/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('site:frontMenu', function (el) {
        el.querySelector('.level1.children').classList.add('down');
        el.querySelectorAll('.level1.children > a').forEach(function (a) {
            a.addEventListener('click', function (e) {
                if (document.body.offsetWidth + 15 >= 992) {
                    e.preventDefault();
                    var li = a.closest('li');
                    Array.prototype.forEach.call(li.parentNode.children, function (l) {
                        l.classList.remove('down');
                    });
                    li.classList.add('down');
                }
            });
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
